<div class="wrapper__form container mt-5 mb-3 border__form text-center" style="max-width: 500px">
  <img
    src="assets/img/Logo__Justifacil.png"
    alt="Logo JustiFácil"
    class="mb-4"
    style="max-height: 60px"
  />

  <h2 class="mb-2 text-primary">{{ 'verificacion_identidad.titulo' | translate }}</h2>
  <p class="text-muted mb-4">{{ 'verificacion_identidad.mensaje' | translate }}</p>

  <h4 class="mb-3 fw-bold">
    {{ 'verificacion_identidad.demanda' | translate }} {{tramiteId}}
    <span class="text-danger"></span>
  </h4>

  <form [formGroup]="formularioCorreo" (ngSubmit)="enviarCodigoOTP()">
    <div class="form-group mb-3 text-start">
      <label for="correo" class="form-label fw-semibold">{{ 'verificacion_identidad.ingrese_correo' | translate }}</label>
      <input
        type="email"
        id="correo"
        formControlName="correo"
        class="form-control"
        [ngClass]="{ 'is-invalid': enviado && formularioCorreo.get('correo')?.invalid }"
        placeholder="{{ 'verificacion_identidad.placeholder_correo' | translate }}"
        autocomplete="off"
      />
      <div class="invalid-feedback" *ngIf="formularioCorreo.get('correo')?.errors?.['required']">
        {{ 'verificacion_identidad.error_requerido' | translate }}
      </div>
      <div class="invalid-feedback" *ngIf="formularioCorreo.get('correo')?.errors?.['pattern']">
        {{ 'verificacion_identidad.error_formato' | translate }}
      </div>
    </div>
    <button type="submit" class="btn btn-primary w-100"
    aria-label="Siguiente">
      {{ 'verificacion_identidad.boton_siguiente' | translate }}
    </button>

    <div class="text-danger mt-3" *ngIf="mensajeError">
      {{ mensajeError }}
    </div>
  </form>

  <p class="mt-4 text-muted small">
    {{ 'verificacion_identidad.politica' | translate }}
  </p>
</div>
